/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../../../store';
import { pathOr, isEmpty } from 'ramda';
import { Thumbnail } from './Thumbnail';
import { IconMvk } from './Icons/IconMvk';
import { setNewbuildingMvkIsWidgetOpenAction } from '../../../../store/newbuilding_mvk';
import { IGetNewbuildingPolygonsResponse } from '../../../../repositories/newbuilding-mvk/v2/get-newbuilding-polygons';

export const mvkThumbnailSelector = (state: IState): string | null => {
  return pathOr(null, ['offerData', 'tourV2', 'interactivePlan', 'thumbnail'], state);
};
export const mvkSelector = (state: IState): IGetNewbuildingPolygonsResponse | null => {
  const mvkData = pathOr(null, ['newbuildingMvk', 'MVKData'], state);

  return isEmpty(mvkData) ? null : mvkData;
};

export const MvkThumbnailContainer = () => {
  const dispatch = useDispatch();
  const mvkThumbnail = useSelector(mvkThumbnailSelector);
  const mvkData = useSelector(mvkSelector);
  const handleClick = React.useCallback(() => {
    dispatch(setNewbuildingMvkIsWidgetOpenAction(true));
  }, []);

  if (!mvkThumbnail || !mvkData) {
    return null;
  }

  return <Thumbnail onClick={handleClick} img={mvkThumbnail} text="Поэтажный план" icon={<IconMvk />} />;
};

MvkThumbnailContainer.displayName = 'MvkThumbnailContainer';
